/**
 * 提取服务端可直接展示的错误消息。
 *
 * 业务校验失败虽然使用 4xx 状态码，但请求和响应链路都是正常的，
 * 因此必须优先保留服务端给出的可操作原因，不能误报为网络故障。
 */
function getServerMessage(error) {
  const data = error && error.response && error.response.data;

  // 兼容旧接口直接返回纯文本错误的情况。
  if (typeof data === 'string' && data.trim()) {
    return data.trim();
  }

  // 新接口统一使用 JSON 对象的 message 字段承载用户可见原因。
  if (data && typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }

  // ASP.NET Core 自动模型校验使用 errors 字典，而不是 message 字段。
  if (data && data.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
    const entries = Object.entries(data.errors);
    const hasConcreteFieldError = entries.some(([key]) => key.toLowerCase() !== 'model');
    const messages = [];

    entries.forEach(([key, value]) => {
      // JSON 转换失败时，model 必填是连带错误，不应干扰真正的字段原因。
      if (hasConcreteFieldError && key.toLowerCase() === 'model') {
        return;
      }

      const values = Array.isArray(value) ? value : [value];
      values.forEach((item) => {
        if (typeof item !== 'string') {
          return;
        }

        const message = item.trim();
        if (message && !messages.includes(message)) {
          messages.push(message);
        }
      });
    });

    if (messages.length) {
      return messages.join('；');
    }
  }

  // RFC 7807 允许只提供 detail 或 title；traceId 不属于用户可见错误原因。
  if (data && typeof data.detail === 'string' && data.detail.trim()) {
    return data.detail.trim();
  }

  if (data && typeof data.title === 'string' && data.title.trim()) {
    return data.title.trim();
  }

  return '';
}

/**
 * 按明确程度选择后台 HTTP 错误提示。
 *
 * 原始异常仍由 Axios 拦截器继续 reject；本函数只负责用户可见文本，
 * 不改变调用方依赖的异常对象和控制流。
 */
export function getHttpErrorMessage(error) {
  const serverMessage = getServerMessage(error);
  if (serverMessage) {
    return serverMessage;
  }

  const clientMessage = error && typeof error.message === 'string' ? error.message.trim() : '';
  const isNetworkFailure = !clientMessage
    || clientMessage === 'Network Error'
    || (error && error.code === 'ECONNABORTED')
    || /^timeout\b/i.test(clientMessage);

  return isNetworkFailure ? '网络错误' : clientMessage;
}
